<template>
  <div class="transactions-block">
    <div class="change-status-payments-block">
      <button
        :class="[`status-button ${usedStatusButton === 1 && 'active'}`]"
        @click="changeUsedStatusButton(1)"
      >
        {{ $t("homePage.settings") }}
      </button>
      <button
        :class="[`status-button ${usedStatusButton === 2 && 'active'}`]"
        @click="changeUsedStatusButton(2)"
      >
        {{ $t("homePage.actticity") }}
      </button>
      <button
        :class="[`status-button ${usedStatusButton === 3 && 'active'}`]"
        @click="changeUsedStatusButton(3)"
      >
        {{ $t("homePage.history") }}
      </button>
    </div>

    <settings-list
      v-if="usedStatusButton === 1"
      :isCheckedOnlinePayments="isCheckedOnlinePayments"
      :isCheckedNFCPayments="isCheckedNFCPayments"
      @set-open-payment-page="setOpenPaymentPage"
      @set-is-use-online-payments="setIsUseOnlinePayments"
      @set-is-open-delete-all="setIsOpenDeleteAll"
      @set-is-use-nfc-payments="setIsUseNFCPayments"
    />
    <ul class="payments-list" v-if="usedStatusButton === 2">
      <vue-perfect-scrollbar class="main-scroll-area">
        <date-fIlter-list
          :value="currentValue"
          :options="dateFilterList"
          @open-filter="openFilter"
          @set-changed-filter="setChangedFilter"
        />
        <transition-group v-if="recentArray.length" name="fade" mode="out-in">
          <li
            v-for="recent of recentArray"
            :key="recent.id"
            class="payments-element"
            @click="$emit('on-open-payment-info', recent)"
          >
            <div
              v-if="recent.category.img"
              class="payments-element-image-block"
            >
              <img
                :src="recent.category.img"
                alt=""
                class="payments-element-image-icon"
              />
            </div>
            <div v-else class="payments-element-image-block">
              <user-icon class="payments-element-image-icon" />
            </div>
            <div class="payments-element-name-block">
              <p class="payments-element-name">{{ recent.title }}</p>
              <p class="payments-element-date">{{ recent.category.title }}</p>
            </div>
            <div class="payments-element-price-block">
              <p
                :class="[
                  `payments-element-price ${
                    recent.status === 'draw' ? 'draw' : ''
                  } 
              ${setCurrentOperations(recent.type.slug)}`,
                ]"
              >
                {{
                  `${recent.type.slug === "expense" ? "-" : ""}${currencySymbol[
                    recent.currency.id
                  ] || ""}${recent.sum}`
                }}
              </p>
              <p class="payments-element-price-origin">
                {{ recent.type.title }}
              </p>
            </div>
          </li>
        </transition-group>
        <div v-else class="null-operations-block">
          <p class="null-operations-text">
            {{ $t("homePage.nullOperations") }} 🔎
          </p>
          <p>{{ $t("homePage.addFirstOperation") }} 🧐</p>
          <button
            @click="$emit('on-create-new-operation', 'cost')"
            class="null-operations-button"
          >
            {{ $t("homePage.add") }}
          </button>
        </div>
      </vue-perfect-scrollbar>
    </ul>
    <ul class="payments-list" v-if="usedStatusButton === 3">
      <vue-perfect-scrollbar class="main-scroll-area">
        <date-fIlter-list
          :value="currentValue"
          :options="dateFilterList"
          @open-filter="openFilter"
          @set-changed-filter="setChangedFilter"
        />
        <transition-group v-if="recentArray.length" name="fade" mode="out-in">
          <li
            v-for="recent of recentArray"
            :key="recent.id"
            class="payments-element"
            @click="$emit('on-open-payment-info', recent)"
          >
            <div
              v-if="recent.category.img"
              class="payments-element-image-block"
            >
              <img
                :src="recent.category.img"
                alt=""
                class="payments-element-image-icon"
              />
            </div>

            <div v-else class="payments-element-image-block">
              <user-icon class="payments-element-image-icon" />
            </div>
            <div class="payments-element-name-block">
              <p class="payments-element-name">{{ recent.title }}</p>
              <p class="payments-element-date">{{ recent.category.title }}</p>
            </div>
            <div class="payments-element-price-block">
              <p
                :class="[
                  `payments-element-price ${
                    recent.status === 'draw' ? 'draw' : ''
                  }
              ${setCurrentOperations(recent.type.slug)}`,
                ]"
              >
                {{
                  `${recent.type.slug === "expense" ? "-" : ""}${currencySymbol[
                    recent.currency.id
                  ] || ""}${recent.sum}`
                }}
              </p>
              <p class="payments-element-price-origin">
                {{ recent.type.title }}
              </p>
            </div>
          </li>
        </transition-group>
        <div v-else class="null-operations-block history">
          {{ $t("homePage.nullOperations") }} 🔎
        </div>
      </vue-perfect-scrollbar>
    </ul>
  </div>
</template>

<script>
import { UserIcon } from "vue-feather-icons";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import DateFIlterList from "../../../components/DateFIlterList.vue";
import SettingsList from "../../../components/mainBlock/SettingsList.vue";
import { setMakeDate } from "../../../helpers/utils";
import { mapMutations } from "vuex";

export default {
  name: "Payments-list-block",
  components: {
    UserIcon,
    VuePerfectScrollbar,
    DateFIlterList,
    SettingsList,
  },
  props: {
    usedStatusButton: {
      type: Number,
      require: true,
    },
    recentArray: {
      type: Array,
      require: true,
    },
    recentActiveArray: {
      type: Array,
      require: true,
    },
  },
  data() {
    return {
      currencySymbol: {
        1: "₴",
        2: "$",
        4: "€",
        6: "zł",
        7: "₴",
      },
      isCheckedNFCPayments: false,
      isCheckedOnlinePayments: true,
      currentValue: {},
      dateFilterList: [],
    };
  },
  async mounted() {
    this.currentValue = { id: 1, value: this.$t("homePage.today") };
  },

  methods: {
    ...mapMutations(["setChangeGlibalNotification"]),
    async setIsUseOnlinePayments() {
      this.isCheckedOnlinePayments = !this.isCheckedOnlinePayments;
      try {
        await window.localStorage.setItem(
          "notifications",
          JSON.stringify(this.isCheckedOnlinePayments)
        );
        await this.$store.dispatch(
          "setSettingsPush",
          this.isCheckedOnlinePayments
        );
      } catch (error) {
        console.log(error.message);
      }
      setTimeout(() => {
        this.$emit("is-open-settings-block");
      }, 600);
    },
    setIsUseNFCPayments() {
      this.isCheckedNFCPayments = !this.isCheckedNFCPayments;
    },
    changeUsedStatusButton(id) {
      this.$emit("on-change-used-button", id);
      if (id === 3) {
        this.currentValue = { id: 4, value: this.$t("homePage.last30Days") };
        this.setChangedFilter({ id: 4, value: this.$t("homePage.last30Days") });
      }
      if (id === 2) {
        this.currentValue = { id: 1, value: this.$t("homePage.today") };
        this.setChangedFilter({ id: 1, value: this.$t("homePage.today") });
      }
    },
    setOpenPaymentPage() {
      this.$emit("on-use-animation", 5);
    },
    setIsOpenDeleteAll() {
      this.$emit("set-is-open-delete-all");
    },
    setCurrentOperations(id) {
      if (id === "income") {
        return "income";
      } else if (id === "expense") {
        return "cost";
      } else {
        return "transfer";
      }
    },
    setChangedFilter(val) {
      this.$emit("set-filter-operations-by-date", setMakeDate(val));
    },
    openFilter() {
      this.dateFilterList = [
        { id: 0, value: this.$t("homePage.allTime") },
        { id: 1, value: this.$t("homePage.today") },
        { id: 2, value: this.$t("homePage.yesterday") },
        { id: 3, value: this.$t("homePage.last7Days") },
        { id: 4, value: this.$t("homePage.last30Days") },
        { id: 5, value: this.$t("homePage.thisMounth") },
      ];
    },
  },
  computed: {
    globalNotification() {
      return this.$store.getters.globalNotification;
    },
    getCurrentLang() {
      return this.$store.getters.getCurrentLang;
    },
  },
  watch: {
    globalNotification(newVal, oldVal) {
      let val = oldVal;
      val;
      this.isCheckedOnlinePayments = newVal;
    },
    getCurrentLang(newVal, oldVal) {
      let val = oldVal;
      val;
      (this.currentValue = { id: 1, value: this.$t("homePage.today") }),
        (this.dateFilterList = [
          { id: 0, value: this.$t("homePage.allTime") },
          { id: 1, value: this.$t("homePage.today") },
          { id: 2, value: this.$t("homePage.yesterday") },
          { id: 3, value: this.$t("homePage.last7Days") },
          { id: 4, value: this.$t("homePage.last30Days") },
          { id: 5, value: this.$t("homePage.thisMounth") },
        ]);
    },
  },
};
</script>

<style scoped>
.transactions-block {
  border-radius: 22px;
  width: 95%;
  margin: 0 auto;
  background: #fff;
  overflow: hidden;
  margin-bottom: 40px;
  box-shadow: 10px 10px 10px #d1d9e6, -10px -10px 10px #f9f9f9;
}

.change-status-payments-block {
  background-color: rgba(0, 0, 0, 0.07);
  overflow: hidden;
  display: flex;
  padding: 5px;
  border-radius: 20px;
  margin: 10px;
}

.status-button {
  transition: all 200ms ease;
  text-align: center;
  width: 100%;
  margin: auto;
  color: #000;
  line-height: 35px;
  font-size: 13px;
  background-size: cover;
  position: relative;
  z-index: 10;
  overflow: visible;
  background-color: transparent;
  transition: all 0.5s ease;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-weight: 600;
}
.status-button.active {
  background-image: var(--main-bg-color);
  color: #fff !important;
}
.status-button.active::after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: inherit;
  z-index: -1;
  transform: scale(0.8) translateY(5px) translateZ(0px);
  filter: blur(12px);
}

.payments-list {
  list-style: none;
}

.payments-element {
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  text-decoration: none;
  cursor: pointer;
}

.payments-element:not(:last-child) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}

.payments-element-image-block {
  width: 45px;
  height: 45px;
  border-radius: 15px;
  background-image: var(--main-bg-color);
  display: flex;
  margin-right: 10px;
}

.payments-element-image-icon {
  color: #000;
  margin: auto;
  width: 25px;
}

.payments-element-name {
  font-family: "Source Sans 3", sans-serif;
  color: #1b1b1b;
  font-size: 16px;
  line-height: 22px;
  font-weight: 700;
  margin-bottom: 0px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 250px;
}

.payments-element-date {
  color: #747474;
  margin-bottom: 30px;
  letter-spacing: -0.2px;
  font-size: 11px;
  opacity: 0.7;
  margin-bottom: 0px;
  line-height: 12px;
}
.payments-element-name-block {
  padding-top: 4px;
}

.payments-element-price-block {
  margin-left: auto;
  padding-top: 4px;
}

.payments-element-price {
  margin-bottom: 0px;
  font-size: 18px;
  line-height: 23px;
  font-weight: 700;
  font-family: "Source Sans 3", sans-serif;
  letter-spacing: -0.6px;
  text-align: end;
}

.payments-element-price.income {
  color: #8cc152;
}

.payments-element-price.cost {
  color: #d84558;
}

.payments-element-price.transfer {
  color: #4a89dc;
}

.payments-element-price.draw {
  color: #f6bb42;
}

.payments-element-price-origin {
  margin-bottom: 0px;
  font-size: 11px;
  color: #747474;
  padding-bottom: 0px;
  letter-spacing: -0.2px;
  text-align: right;
  line-height: 12px;
}

.main-scroll-area {
  width: 100%;
  /* max-height: 45vh; */
  min-height: 10vh;
  padding: 10px 15px 10px 15px;
}

.null-operations-block {
  padding-top: 50px;
  text-align: center;
}

.null-operations-block.history {
  padding-bottom: 50px;
}

.null-operations-text {
  text-align: center;
  max-width: 180px;
  margin: 0 auto;
  font-size: 15px;
  line-height: 23px;
  font-weight: 500;
  color: #747474;
  font-family: "Source Sans 3", sans-serif;
  letter-spacing: -0.6px;
}

.null-operations-button {
  display: block;
  font-family: "Source Sans 3", sans-serif;
  text-transform: uppercase;
  font-weight: 700;
  border-radius: 12px;
  font-size: 13px;
  padding: 14px 20px;
  box-shadow: 0 5px 14px 0 rgba(0, 0, 0, 0.1);
  transition: all 120ms ease;
  background-size: cover;
  position: relative;
  z-index: 10;
  background-image: var(--main-bg-color);
  color: #fff;
  width: 40%;
  border: none;
  cursor: pointer;
  margin: 40px auto 20px auto;
}

.null-operations-button:after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: inherit;
  z-index: -1;
  transform: scale(0.8) translateY(5px) translateZ(0px);
  filter: blur(12px);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
